import React, { Component } from 'react';  
import echarts from 'echarts/lib/echarts';
// 引入柱状图
// import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legend';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default class CalculatorLine extends Component {  
  state = {
    dataYear: []
  }

  componentDidMount() {
    let { dataSource } = this.props;
    let { nowYear, planType } = this.props;
    let dataYear = [];
    let fullYear = new Date().getFullYear();
    let nowMonth = parseInt(new Date().getMonth()+1);
    if(planType == "每月投资方案") {
      for(let i = 0; i <= nowYear*12; i++) {
        if(nowMonth == 13) {
          nowMonth = 1;
          fullYear++;    
        }
        if(nowMonth < 10) {
          dataYear.push(fullYear + "-0" + nowMonth);
        }else {
          dataYear.push(fullYear + "-" + nowMonth);
        }
        nowMonth++;
      }
    }else if(planType == "一次投资方案") {
      for(let i = 0; i <= nowYear; i++) {
        dataYear.push(fullYear+i);
      }
    }
    let option = {
      animation: window.isLess47,
      grid:{
        top: 28,
        left: 50,
        right: 40
      },
      calculable : true,
      tooltip : {
        show:true,
        trigger: 'axis',
        position:[window.winWidth - 160,0],
        axisPointer:{
              type: 'line',
              lineStyle: {
                  color: '#48b',
                  width: 1,
                  type: 'dashed'
              },
              crossStyle: {
                  color: '#1e90ff',
                  width: 1,
                  type: 'dashed'
              },
              shadowStyle: {
                  color: 'rgba(150,150,150,0.3)',
                  width: 'auto',
                  type: 'default'
              }
        },
        backgroundColor:"#FFF",
        textStyle:{
          fontSize:11
        },
        formatter:'<div style="color:rgb(161,168,179); font-size:11; width: 120px; text-align: right;" ><span >{b}</span>{a0}：<span style=color:'+`${true?'rgb(249,98,94)':'#f0f'}`+'>{c0}万元</span> </div>'
      },
      xAxis : [
          {   
              axisLine:{
                  lineStyle:{
                      width:1,
                      color:"#CCC"
                  }
              },
              axisTick:{
                   lineStyle:{
                      width:0,
                      color:"#9BC4D8"
                  }
              },
              type : 'category',
              boundaryGap : false,
              data : dataYear
          }
      ],
      yAxis : [
        {
              type : 'value',
              scale: true,
              // name:'(人)',
              axisLine:{
                  lineStyle:{
                      width:0,
                      color:"rgb(160,167,176)"
                  }
              },
              axisTick:{
                   lineStyle:{
                      width:0,
                      color:"#9BC4D8"
                  }
              }
          }
      ],
      series : [
          {
              name:' ',
              type:'line',
              stack: '总量',
              smooth:true,/*线条有弧度*/
              data: dataSource,
              itemStyle : {  
                  normal : {  
                      color:'#fa063a',  /*#53C6E0*/
                      lineStyle:{  
                          color:'#fa063a'  
                      }  
                  }  
              }, 
          }
      ],
      color:['#fa063a']
    };
    var myChart = echarts.init(document.getElementById('echartBox'), null, {renderer: 'svg'});
    // 绘制图表
    myChart.setOption(option);
  }

  render() {
      return (  
        <div style={{
          display: "-webkit-flex",
           backgroundColor:'#fff',
            paddingLeft: 13,
            paddingRight: 13,
            height: 200,
            WebkitJustifyContent: "center",
            WebkitAlignItems: "center",
            paddingTop: 40
        }}>  
           <div>
            <div style={{color:"rgb(160,167,176)", fontSize: 11, marginBottom: 10, marginLeft: 13}}>(万元)</div>
            <div id="echartBox" style={{width: window.winWidth, height: 200}} />
          </div>
        </div>  
      );  
  }  
}  




// WEBPACK FOOTER //
// ./src/components/recommend/CalculatorLine.js